import React, { useEffect, useState } from 'react';
import { fetchArchivePosts, formatArchiveDate } from '../lib/archiveFeeds';
import './DevBlogPreview.css';

function ArchiveSourcePreview({ source, visitLabel = '전체 보기 →' }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setPosts([]);

    fetchArchivePosts(source.feed)
      .then((data) => {
        if (!cancelled) setPosts(data);
      })
      .catch(() => {
        if (!cancelled) setPosts([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [source]);

  return (
    <div className="devblog-preview">
      <a
        href={source.url}
        target="_blank"
        rel="noopener noreferrer"
        className="devblog-preview-card"
      >
        <div className="devblog-preview-card-top">
          <span className="devblog-preview-kicker">{source.kicker}</span>
          <span className="devblog-preview-cta">{visitLabel}</span>
        </div>
        <span className="devblog-preview-domain">{source.domain}</span>
        <p className="devblog-preview-sub">{source.title}</p>
      </a>

      <div className="devblog-preview-list">
        {loading && <p className="devblog-preview-hint">불러오는 중…</p>}

        {!loading && posts.length > 0 && (
          <>
            <p className="devblog-preview-list-title">최근 글</p>
            <ul>
              {posts.map((post, i) => (
                <li key={post.url || post.link || i}>
                  <a
                    href={post.link || post.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="devblog-preview-row"
                  >
                    <span className="devblog-preview-num">{String(i + 1).padStart(2, '0')}</span>
                    <span className="devblog-preview-link">{post.title}</span>
                    <span className="devblog-preview-right">
                      {(post.date || post.pubDate) && (
                        <span className="devblog-preview-date">
                          {formatArchiveDate(post.date || post.pubDate)}
                        </span>
                      )}
                      <span className="devblog-preview-arrow">→</span>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </>
        )}

        {!loading && posts.length === 0 && (
          <p className="devblog-preview-hint">{source.domain}에서 기록을 볼 수 있습니다.</p>
        )}
      </div>
    </div>
  );
}

export default ArchiveSourcePreview;
